import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  noindex = false,
  structuredData = null,
}) => {
  const siteTitle = 'KittenState';
  const defaultDescription = 'KittenState is a trusted cattery specializing in Scottish Fold and Scottish Straight kittens. Learn about our kittens, parents, health care, and adoption process.';
  const defaultImage = 'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=1200&h=630&fit=crop';
  const siteUrl = 'https://kittenstate.com';
  
  const fullTitle = title ? (title.includes(siteTitle) ? title : `${title} | ${siteTitle}`) : siteTitle;
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const canonicalUrl = url || siteUrl;

  // Default LocalBusiness structured data
  const defaultStructuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "KittenState",
    "description": "Trusted Scottish Fold and Scottish Straight kitten breeder in Covington Township, Pennsylvania.",
    "url": "https://kittenstate.com",
    "telephone": "+1-929-333-1936",
    "email": "sales@kittenstate.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Covington Township",
      "addressRegion": "PA",
      "postalCode": "18424",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.4589",
      "longitude": "-75.3279"
    },
    "openingHours": ["Mo-Sa 09:00-19:00"],
    "priceRange": "$$",
    "image": defaultImage,
    "sameAs": []
  };

  const jsonLd = structuredData || defaultStructuredData;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      
      {/* Additional SEO */}
      <meta name="author" content="KittenState" />
      <meta name="geo.region" content="US-PA" />
      <meta name="geo.placename" content="Covington Township" />
      <meta name="rating" content="General" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default SEO;
